<template>
  <div class="about-container pre-formatted">
    <div class="container" v-html="content">{{ content }}</div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "About Us",
  data() {
    return {
      content: ""
    };
  },
  methods: {
    ...mapActions("pages", ["fetchPageDetailsBySlug"])
  },
  mounted() {
    this.fetchPageDetailsBySlug("about-us").then(res => {
      this.content = res.data.data;
    });
  }
};
</script>
<style lang="scss">


.pre-formatted {
  white-space: pre-wrap;
}


.about-container * {
  font-family: "Open Sans", sans-serif !important;
}
</style>
